module.exports = __webpack_public_path__ + "fonts/Rubik-BoldItalic.26955e3.woff2";